import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DsCookieConsentComponent } from './components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DsCookieConsentComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('webapp');
}
